import { createIntentType } from '../intent';
/**
 * Adds dynamic behaviors that act upon the value of a component’s props.
 *
 * @see https://sail.stripe.me/apis/dynamic
 */ export const dynamic = createIntentType('dynamic', {
    add () {
        return null;
    },
    merge () {
        return null;
    }
});

//# sourceMappingURL=dynamic.js.map